
import { useState, useEffect } from "react";
import OtpInput from "react-otp-input";
import "./Startsession..css";
import { Link, useNavigate } from "react-router-dom";
import { handleStartsession, showToast } from "../Utils/utils";
import Loader from "../../Component/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { Initiatestartsession } from "../Redux/action/Initiatesession";
import { useLocation } from "react-router-dom";


const Startsession = () => {
  let location = useLocation();
  let session_id = new URLSearchParams(location.search).get('id');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [otp, setOtp] = useState();
  const [second, setSecond] = useState(30)
  const [Loading, setLoading] = useState(false)
  const [isTimerCompleted, setIsTimerCompleted] = useState(false);
  const { sessionData, loading, error } = useSelector((state) => state.session);




  // }, [sessionData?.data?.otp, second]);



  const handleInitiate = async () => {
    try {
      const response = await dispatch(Initiatestartsession(session_id));
      showToast(response.message, "success");
      setSecond(30);
      setIsTimerCompleted(false);
      return response;
    } catch (error) {
      const errorMessage = error?.message || "An unexpected error occurred";
      showToast(errorMessage, "error");
      console.error("Error initiating session:", error);
    }
  };


  const handleOptchnage = (otpValue) => {
    console.log(typeof otpValue, "otpvalue....")
    setOtp(otpValue)
  }


  const Startsession = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      const response = await handleStartsession({ session_id: session_id, otp: otp })
      showToast(response?.message, "success")
      if (response.status === 200) {
        setTimeout(() => {
          window.location.href = `/endsession?id=${session_id}`;
        }, 1200);
      }

    } catch (error) {
      showToast(error.message, "error")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const session_id = new URLSearchParams(location.search).get('id');
    const bookingsessionid = localStorage.getItem("sessionid")
    if (!session_id || session_id !== bookingsessionid) {
      navigate('/dashboard');
      return;
    }
    if (sessionData?.data?.otp && second > 0) {
      const timer = setInterval(() => {
        setSecond((prevSecond) => {
          if (prevSecond > 1) {
            return prevSecond - 1;
          } else {
            clearInterval(timer);
            setIsTimerCompleted(true);
            return 0;
          }
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [sessionData?.data?.otp, second]);




  return (
    <>
      {Loading && <Loader />}
      <div className="top-Otp">
        <div className="otp-wrapper px-4">
          <div className="mt-5">
            <Link to="/">
              <img className="img-fluid left-arrow-img " src="/Images/left-arrow.svg" alt="Logo" />
            </Link>
          </div>
          <form className="d-flex flex-column gap-3 justify-content-center" onSubmit={Startsession}>
            <h4 className="title mt-3 ms-2">The user is sending your OTP.</h4>
            <div className="d-flex gap-2 ms-2">
              <label className="labeltext" htmlFor="OTP">
                Enter the OTP sent to  {sessionData?.data?.user?.phone_number}
              </label>
              {/* <span className="edit-otp">Edit</span> */}
            </div>
            <div className="otp-wrppaer">
              <OtpInput className="w-100"
                value={otp}
                onChange={handleOptchnage}
                numInputs={4}
                separator={<span> </span>}
                renderInput={(props) => (
                  <input className="otp-input gap-5"
                    {...props}
                    type="tel"
                    pattern="[0-9]*"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    style={{
                      width: "50px",
                      padding: "10px",
                      margin: "0 8px",
                      borderRadius: "10px",
                      background: "#ffffff",
                      border: "1px solid #d0d5dd",
                      boxShadow: "0px 1px 2px 0px #1018280d",
                      textAlign: "center",
                      fontSize: "16px",
                      fontWeight: "bold",
                      outline: "none",
                      color: "#000000",
                    }}
                  />
                )}

              />
            </div>
            <div className="d-flex align-items-center">
              {second > 0 ? (
                <span className="resend-otp-btn ms-2">
                  Resend OTP in 00:{second > 9 ? second : `0${second}`}
                </span>
              ) : (
                <span
                  className="resend-otp-resp ms-2"
                  onClick={handleInitiate}
                  style={{ cursor: "pointer" }}
                >
                  Resend OTP
                </span>
              )}

            </div>


            <div className='submitbtn-res d-sm-block d-lg-none d-md-none'>
              <button className='continue-btn-res mt-2' type='submit'>
                <span className='continuebtn-text'>Continue</span>
              </button>
            </div>
            <div className='submitbtn-wrapper d-lg-block d-md-block d-xl-block d-xxl-block d-none'>
              <button className='continue-btn mt-3' type='submit'>
                <span className='continuebtn-text'>Continue</span>
              </button>
            </div>
          </form>

        </div>
      </div>
    </>
  );
};
export default Startsession;
